var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurricane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 510"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 137",
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#6222D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.942 11.6059C13.0469 11.4611 13.1178 11.2913 13.149 11.1109C13.1802 10.9305 13.1707 10.7447 13.1213 10.569C13.0718 10.3934 12.984 10.233 12.865 10.1015C12.746 9.96994 12.5994 9.871 12.4375 9.813L10.2499 9.0284L10.9794 6.6769C11.0238 6.53395 11.0415 6.38301 11.0316 6.23269C11.0217 6.08237 10.9843 5.93563 10.9217 5.80083C10.859 5.66604 10.7723 5.54583 10.6665 5.44708C10.5606 5.34833 10.4377 5.27296 10.3048 5.22529C10.0363 5.129 9.74331 5.15134 9.49017 5.28741C9.36483 5.35478 9.25306 5.44804 9.16123 5.56187C9.0694 5.67569 8.99932 5.80785 8.95499 5.95081L7.88837 9.39202C7.84407 9.53497 7.8264 9.68591 7.83636 9.83621C7.84632 9.98651 7.88372 10.1332 7.94642 10.268C8.00912 10.4027 8.09589 10.5229 8.20178 10.6215C8.30766 10.7202 8.43059 10.7955 8.56354 10.8431L10.3331 11.4774C9.30986 12.892 6.5422 20.4513 12.942 11.6059Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane);
export default __webpack_public_path__ + "static/media/hurricane.2b52c0c873c661d0b5bfd6fcdfc38a9e.svg";
export { ForwardRef as ReactComponent };